module.exports = __webpack_public_path__ + "img/CB_Hellborn Shaman.0dce5006.gif";